import AbstractEngagementComponent from './abstract-engagement.component';
import { EngagementType } from '../interfaces/dynamic-yield.interface';

export class DyEngagementComponent extends AbstractEngagementComponent {
    constructor(element: HTMLElement) {
        super(element);
    }

    protected bindEvents(): void {
        this.element.addEventListener('click', () => {
            if (!window.DYO?.ActiveConsent?.isUserOptOut() &&
                this.decisionId &&
                this.engagementType
            ) {
                this.dynamicYieldService.fireEngagementEvent({
                    type: this.engagementType,
                    decisionId: this.decisionId,
                });
            }
        });
    }

    protected get decisionId(): string {
        return this.element.dataset.decisionId ?? '';
    }

    protected get engagementType(): EngagementType {
        return this.element.dataset.engagementType as EngagementType;
    }
}
